import React, { useState } from "react";
import PlatformConfigCard from "./PlatformConfigCard";

const MobileAppConfig = ({ config, onUpdate }) => {
  const [loading, setLoading] = useState({ android: false, ios: false });

  const handlePlatformUpdate = async (platform, configData) => {
    setLoading((prev) => ({ ...prev, [platform.toLowerCase()]: true }));
    try {
      await onUpdate(platform, configData);
    } finally {
      setLoading((prev) => ({ ...prev, [platform.toLowerCase()]: false }));
    }
  };

  return (
    <div className="mobile-app-config">
      <div className="row">
        {/* Android Configuration */}
        <div className="col-lg-6 mb-4">
          <PlatformConfigCard
            platform="Android"
            icon="fab fa-android"
            iconColor="success"
            config={config?.android}
            onUpdate={(configData) =>
              handlePlatformUpdate("android", configData)
            }
            loading={loading.android}
          />
        </div>

        {/* iOS Configuration */}
        <div className="col-lg-6 mb-4">
          <PlatformConfigCard
            platform="iOS"
            icon="fab fa-apple"
            iconColor="dark"
            config={config?.ios}
            onUpdate={(configData) => handlePlatformUpdate("ios", configData)}
            loading={loading.ios}
          />
        </div>
      </div>

      {/* Configuration Summary */}
      <div className="row mt-4">
        <div className="col-12">
          <div className="card border-0 shadow-sm">
            <div className="card-header bg-light">
              <h6 className="fw-bold mb-0">
                <i className="fas fa-info-circle me-2"></i>
                Configuration Summary
              </h6>
            </div>
            <div className="card-body">
              <div className="row">
                <div className="col-md-6">
                  <h6 className="fw-bold text-success">
                    <i className="fab fa-android me-2"></i>
                    Android
                  </h6>
                  <div className="row">
                    <div className="col-sm-6">
                      <small className="text-muted">Minimum Version:</small>
                      <div className="fw-bold">
                        {config?.android?.minVersion || "Not set"}
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <small className="text-muted">Latest Version:</small>
                      <div className="fw-bold">
                        {config?.android?.latestVersion || "Not set"}
                      </div>
                    </div>
                  </div>
                  <div className="mt-2">
                    <span
                      className={`badge ${
                        config?.android?.force ? "bg-danger" : "bg-success"
                      }`}
                    >
                      {config?.android?.force
                        ? "Force Update Required"
                        : "Optional Update"}
                    </span>
                  </div>
                </div>

                <div className="col-md-6">
                  <h6 className="fw-bold text-dark">
                    <i className="fab fa-apple me-2"></i>
                    iOS
                  </h6>
                  <div className="row">
                    <div className="col-sm-6">
                      <small className="text-muted">Minimum Version:</small>
                      <div className="fw-bold">
                        {config?.ios?.minVersion || "Not set"}
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <small className="text-muted">Latest Version:</small>
                      <div className="fw-bold">
                        {config?.ios?.latestVersion || "Not set"}
                      </div>
                    </div>
                  </div>
                  <div className="mt-2">
                    <span
                      className={`badge ${
                        config?.ios?.force ? "bg-danger" : "bg-success"
                      }`}
                    >
                      {config?.ios?.force
                        ? "Force Update Required"
                        : "Optional Update"}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MobileAppConfig;
